import { render, staticRenderFns } from "./ChromeColorIcon.vue?vue&type=template&id=839a465a&scoped=true"
import script from "./ChromeColorIcon.vue?vue&type=script&lang=js"
export * from "./ChromeColorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839a465a",
  null
  
)

export default component.exports